@let reportData = report();

<div class="alert-container px-4 mt-4 flex flex-col gap-2">
  @if (reportData && !reportData.is_shared) {
    <app-pan-inline-alert type="warning">
      This report hasn't been shared. Sharing is required for other users to view this report.
    </app-pan-inline-alert>
  }
</div>

@if (loading()) {
  <app-pan-blank-slate>
    <app-pan-spinner></app-pan-spinner>
    &nbsp;Loading...
  </app-pan-blank-slate>
}

@if (reportData) {
  <app-pan-card
    data-testid="asset-recovery-report-card"
    class="block mb-20"
    [isPageContainer]="true"
    pageContainerSize="xl"
    [header]="reportData.title"
    [subheader]="subtitle()"
  >
    <div rightActions class="flex gap-2">
      <button panButton color="primary" data-testid="asset-recovery-invoice-button" (click)="isInvoiceVisible.set(true)">
        {{ canManageAssetRecovery() ? 'Manage AR Invoice' : 'View Invoice' }}
      </button>
      @if (canManageAssetRecovery()) {
        <app-share-email-modal
          modalTitle="Share Link to Asset Recovery Report"
          [locationIds]="reportLocationIds()"
          [disabled]="isSharing()"
          [isSharing]="isSharing()"
          (share)="share($event)"
          searchType="locations"
        ></app-share-email-modal>
      }
    </div>

    <div class="flex flex-col gap-2">
      <app-pan-section-header [title]="locationName()"></app-pan-section-header>

      <ag-grid-angular [rowData]="reportRows()" [columnDefs]="columnDefs" [gridOptions]="tableDef"></ag-grid-angular>

      <app-discussion-thread type="asset-recovery-report" [id]="reportData.id"></app-discussion-thread>
    </div>
  </app-pan-card>
}

<app-footer [public]="true" [copyright]="true"></app-footer>

@if (reportData) {
  <app-asset-recovery-invoice-modal
    [report]="reportData"
    [readOnly]="!canManageAssetRecovery()"
    [saving]="isInvoiceSaving()"
    [(isVisible)]="isInvoiceVisible"
    (confirmed)="updateInvoice($event)"
  ></app-asset-recovery-invoice-modal>
}
